/*
 * @Author: zhouyan
 * @Date: 2025-06-03 11:42:09
 * @LastEditors: zhouyan
 * @LastEditTime: 2025-06-04 15:24:15
 * @Description: 
 * 
 * Copyright (c) 2025 by 重庆大学电子音像出版社有限公司, All Rights Reserved. 
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

app.mount('#app')

